import React from "react";
import { Helmet } from "react-helmet";

const PageTitle = ({ title }) => {
    return(
        <Helmet title={"App Health | " + title }/>
    )
}

export default PageTitle;